<template>
  <div v-if="isBranded()">
    <div :class="!isSushiHub && 'p-4' ">
      <div class="login-container topmenu" v-if="showLogin">
        <intro-login></intro-login>
      </div>
      <resturants-filter />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ResturantsFilter from "./ResturantsFilter";
import IntroLogin from "./../IntroLogin";
import shared from "../../../sharedscripts/master/Resturant/Resturants.js";
import { DetectWC } from "../../../mixins/wcDetector";
import { DetectBrand } from "../../../mixins/brandDetector";

export default {
  name: "Resturants",
  components: {
    ResturantsFilter,
    IntroLogin,
  },
  data() {
    return {
      ...shared.data(),
    };
  },
  computed: {
    ...shared.computed,
    ...mapGetters(["hqDoc"]),
    showLogin() {
      const isLoginEnabled =
          this.hqDoc &&
          this.hqDoc.ViewComponentConfigs &&
          this.hqDoc.ViewComponentConfigs.LogIn;
      const isWC = DetectWC.methods.isWC();
      const isBranded = DetectBrand.methods.isBranded() == true;
      return isLoginEnabled && isWC == true && isBranded == true;
    },
    isSushiHub() {
      return this.hqDoc && this.hqDoc.IsSushiHub
    }

  },
  methods: {
    ...shared.methods,
  },
  filters: {
    ...shared.filters,
  },
  created() {
    if (
        !this.isWC() &&
        !this.isBranded() &&
        process.env.NODE_ENV === "production"
    ) {
      window.location = "https://www.abacus.co/";
    }
  },
};
</script>
